import { IconNames } from '@blueprintjs/icons';
import { FormSectionWithRows } from '@strata/react-form-section';
import { MailToHyperlink } from '@strata/react-hyperlink';
import { Icon } from '@strata/react-status-icons';

export const EscalateClinicalConcern = () => (
    <FormSectionWithRows
        sectionTitle={
            <div className="sds_escalate-clinical-concern__title">
                <Icon
                    icon={IconNames.ENVELOPE}
                    size={18}
                    className="sds_escalate-clinical-concern__title-icon padding__right--small"
                />
                <MailToHyperlink
                    linkText="Escalate a Clinical Concern"
                    emailAddress="support@freemarkethealth.com"
                />
            </div>
        }
        rowOneContent={
            <div className="sds_escalate-clinical-concern__description">
                Alert Free Market Health to issues that may indicate lapse of treatment or evidence
                of diversion or non-adherence, such as multiple unsuccessful attempts to contact the
                member, excessive on-hand inventories reported, or member-reported side effects.
                Free Market Health will triage concerns on behalf of and in coordination with the
                member&apos;s health plan.
            </div>
        }
    />
);
